import { useEffect, useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";

type PageNavProps = {
  children: ReactNode;
};

const PageNav = ({ children }: PageNavProps) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setOpen(false), [location.pathname]);

  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [open]);

  return (
    <>
      <button
        type="button"
        className="page-nav-toggle"
        aria-expanded={open}
        aria-controls="page-nav-drawer"
        aria-label={open ? "Close page menu" : "Open page menu"}
        onClick={() => setOpen((isOpen) => !isOpen)}
      >
        <i className="ti ti-menu-2" />
      </button>
      <div id="page-nav-drawer" className={`sidebar sidebar-drawer ${open ? "sidebar-open" : ""}`}>
        {children}
      </div>
      {open && (
        <button
          type="button"
          className="page-nav-backdrop"
          aria-label="Close page menu"
          onClick={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default PageNav;
